import React from 'react';
import {Image, Platform,StyleSheet, View} from 'react-native';
import Animated, {SlideInLeft, SlideOutRight} from 'react-native-reanimated';

import Text from '../../../components/ui-controls/Text';
import ProductImage from '../../../images/brand/giftCardsShop/product-image.png';
import {toAUD} from '../../../utils/functions';

type GiftCardStoreCartLineItemProps = {
  item: any;
  index: any;
  disabled?: boolean;
  isTotalVisible?: any;
  isGiftCardStore?: boolean;
};

const GiftCardStoreCartLineItem = ({item}: GiftCardStoreCartLineItemProps) => (
  <Animated.View
    testID="cart-line-item"
    entering={SlideInLeft}
    exiting={SlideOutRight}
    style={styles.container}>
    <View style={styles.imageContainer}>
      <Image source={ProductImage} style={styles.image} resizeMode="contain" />
    </View>
    <View style={styles.textContainer}>
      <Text style={styles.text}>{toAUD(item.sell_price_cents)} Gift Card</Text>
    </View>
  </Animated.View>
);

const styles = StyleSheet.create({
  container: {
    width: '100%',
    flexDirection: 'row',
    justifyContent: 'center',
  },
  imageContainer: {
    width: '50%',
    paddingRight: 4,
  },
  textContainer: {
    justifyContent: 'center',
    paddingLeft: 4,
  },
  image: {
    borderRadius: 6, // TODO: TMP
    aspectRatio: 3 / 2,
    ...Platform.select({
      native: {
        flex: 1,
        width: undefined,
        height: undefined,
      },
    }),
  },
  text: {
    textAlign: 'center',
  },
});

export default GiftCardStoreCartLineItem;
